import { render, staticRenderFns } from "./AddNew.vue?vue&type=template&id=433175b4&"
var script = {}
import style0 from "./AddNew.vue?vue&type=style&index=0&id=433175b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports